module.exports = require("./zh-Hant-MO.d.ts");